import apiClient from "./ApiClient";

export const getLeaveTypes = async (filter = {}) => {
  try {
    const response = await apiClient.post(`/api/LeaveType/get`, filter);
    return response.data;
  } catch (error) {
    console.error("Error fetching leave types:", error);
    throw error;
  }
};

export const saveLeaveType = async (leaveType) => {
  const response = await apiClient.post(`/api/LeaveType/save`, leaveType);
  return response.data;
}; 